import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

import "assets/scss/material-dashboard-pro-react/plugins/_plugin-react-datepicker.css";
import styles from "assets/jss/material-dashboard-pro-react/views/buttonsStyle.js";
import "react-datepicker/dist/react-datepicker.css";

// react component for creating dynamic tables
// @material-ui/core components
// import { makeStyles } from "@material-ui/core/styles";
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons
// core components
import { useTranslation } from "react-i18next";
import Favorite from "components/Profile/Favorite.js";

import getFavorites from "api/restaurant/getFavorite.js";

const useStyles = makeStyles(styles);

export default function UserFavorites(props) {
  const [favorites, setFavorites] = useState([]);
  useEffect(() => {
    if (props.user && props.user._id) {
      getFavorites() //user._id, 3, favorites.length)
        .then(res => {
          if (res && res.length > 0) {
            const fav = [].concat(favorites).concat(res);
            setFavorites(fav);
          }
        })
        .catch(err => console.log("err", err));
    }
  }, [props.user]);
  const classes = useStyles();
  const { t, i18n } = useTranslation();

  const showMoreResults = () => {
    getFavorites() //user._id, 3, favorites.length)
      .then(res => {
        if (res && res.favorites && res.favorites.length > 0) {
          favorites.push(res.favorites);
        }
        setFavorites(favorites);
      })
      .catch(err => console.log("err", err));
  };

  console.log("props.user", props.user);
  return (
    <div className="main-banner-home">
      <div className="user-data-title">
        {/* {props.user.favoriteNumber && props.user.favoriteNumber > 0 ? ( */}
        <span>{props.user.favoriteNumber} Preferiti</span>

        {/* <span>Non ci sono ancora preferiti</span> */}
      </div>
      {favorites && favorites.length > 0 ? (
        <div className="user-activities-container">
          <div className="user-contents-favorites-container">
            {favorites.map((el, index) => {
              const favorite = {
                status: el.status,
                name: el.restaurantId.name,
                addressIT: el.restaurantId.addressIT,
                address: el.restaurantId.address,
                addressEN: el.restaurantId.addressEN,
                isFavorite: el.restaurantId.isFavorite,
                facebook: el.restaurantId.facebook,
                viewStyleSelected: el.restaurantId.viewStyleSelected,
                photo: el.restaurantId.photos,
                alias: el.restaurantId.alias
              };
              return (
                <div
                  key={`user-favorites-${index.toString()}`}
                  className="user-contents-review-position"
                >
                  <Favorite favorite={favorite} attributes={props.attributes} />
                </div>
              );
            })}
          </div>
        </div>
      ) : null}
      {favorites.length < props.user.favoriteNumber ? (
        <div style={{ width: "100%", display: "flex" }}>
          <button
            className="show-more-results"
            style={{ margin: "30px auto" }}
            onClick={() => {
              showMoreResults();
            }}
          >
            Mostra altro
          </button>
        </div>
      ) : null}
    </div>
  );
}
UserFavorites.propTypes = {
  updateCity: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
  updateUser: PropTypes.func.isRequired,
  attributes: PropTypes.object.isRequired
};
